import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useAuth, loginWithGoogle } from "@/lib/auth";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin");
  }, [user, loading, navigate]);

  return (
    <main className="relative flex min-h-screen items-center justify-center bg-[#050505] px-6" data-testid="login-page">
      <button
        data-testid="login-back-btn"
        onClick={() => navigate("/")}
        className="absolute left-6 top-6 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-white/50 transition-colors hover:text-white"
      >
        <ArrowLeft className="h-4 w-4" /> Back to site
      </button>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md rounded-2xl border border-white/10 bg-[#0a0a0a] p-10"
      >
        <div className="mb-2 flex items-center gap-2">
          <span className="font-display text-xl font-bold uppercase tracking-tight">Visions</span>
          <span className="h-1.5 w-1.5 rounded-full bg-[#FF3B30]" />
        </div>
        <h1 className="font-display text-3xl font-bold uppercase leading-[0.95] tracking-tighter">
          Team Access
        </h1>
        <p className="mt-4 text-sm font-light leading-relaxed text-white/55">
          Sign in with your authorized Google account to view and manage incoming
          quote requests.
        </p>

        <button
          data-testid="google-signin-btn"
          onClick={loginWithGoogle}
          className="group mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-white px-6 py-4 font-mono text-xs uppercase tracking-[0.15em] text-black transition-colors hover:bg-[#FF3B30] hover:text-white"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06L5.84 9.9C6.71 7.31 9.14 5.38 12 5.38z" />
          </svg>
          Continue with Google
        </button>

        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-white/30">
          Restricted · Authorized personnel only
        </p>
      </motion.div>
    </main>
  );
}
